import { render } from "./offer.vue?vue&type=template&id=7b873fa6&scoped=true"
import script from "./offer.vue?vue&type=script&lang=js"
export * from "./offer.vue?vue&type=script&lang=js"

import "./offer.vue?vue&type=style&index=0&id=7b873fa6&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b873fa6"]])

export default __exports__